export default __webpack_public_path__ + "static/media/canoes.77425985.svg";